module.exports = {
  sanity: {
    projectId: process.env.GATSBY_SANITY_PROJECT_ID || 'paxrx6m7',
    dataset: process.env.GATSBY_SANITY_DATASET || 'production',
    tag: process.env.GATSBY_SANITY_API_TAG || 'default'
  }
};
